module.exports = __webpack_public_path__ + "img/bg-normal.045f3e0a.png";